"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    miao: 'Miếu',
    wang: 'Vượng',
    de: 'Đắc',
    li: 'Lợi',
    ping: 'Bình',
    bu: 'Bất',
    xian: 'Hạn',
};
